export default {
  default(h, conf, key) {
    return conf.__slot__[key]
  }
}



// WEBPACK FOOTER //
// ./src/components/form/render/slots/el-button.js